import axiosFactory from "./axios.factory";

class ProductCalculationService {
  async getCalculation(productId) {
    const result = await axiosFactory().get(`/product_calculation/${productId}`);
    return result.data.data;
  }

  // Letzten Wareneingang aller Produkte aus dem WMS holen; liefert die Anzahl geaenderter Produkte
  async refreshLastPurchase() {
    const result = await axiosFactory().post("/product_calculation/last_purchase/refresh");
    return result.data.updated;
  }

  async saveCalculation(productId, payload) {
    const result = await axiosFactory().put(`/product_calculation/${productId}`, payload);
    return result.data.data;
  }
}

export default new ProductCalculationService();
